import React, { useState } from "react";

/* Form */
import { Controller, useForm } from "react-hook-form";

/* Material UI */
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

/* Style */
import { useStyles } from "../styles";

/* Hooks */
import { useEnqueueSnackbar } from "../../../../hooks/useEnqueueSnackbar";
import { useSettingDispatchChange } from "../index";

const ValetAreaUpdateTicketSettingsForm = ({
  entityID,
  settingValues,
}) => {
  const classes = useStyles();
  const [areSettingsExpanded, setAreSettingsExpanded] = useState(true);
  const { dispatchSetting } = useSettingDispatchChange();
  const enqueueSnackbar = useEnqueueSnackbar();

  const toggleSettingsExpanded = () => {
    setAreSettingsExpanded(!areSettingsExpanded);
  };

  const { control, setValue } = useForm({
    defaultValues: {
      showupdateticket: settingValues.showUpdateTicket,
    },
  });

  const handleShowUpdateTicketSelectionChanged = async (e) => {
    const targetValue = e.target.checked;

    if (targetValue === settingValues.showUpdateTicket) return;

    if (!(await dispatchSetting(entityID, "valetarea.showupdateticket", targetValue))) {
      setValue("showupdateticket", settingValues.showUpdateTicket);
      enqueueSnackbar("Unable to change Update Ticket Settings", {
        variant: "error",
        tag: "UpdateTicketSettingChangeError",
      });
    }
  };

  return (
    <Grid
      container
      className={classes.panelRoot}
      data-testid="update-ticket-settings-container"
    >
      <Accordion
        data-tag="update-ticket-settings-accordion"
        expanded={areSettingsExpanded}
        TransitionProps={{
          unmountOnExit: true,
        }}
        className={classes.fullWidthAccordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={toggleSettingsExpanded}
        >
          <Typography className={classes.heading}>Update Ticket</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <Controller
                name="showupdateticket"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    role="valetarea-showupdateticket-toggle"
                    label="Show Update Ticket on Shift Session"
                    control={
                      <Switch
                        {...field}
                        id="valetareashowupdateticket"
                        color="primary"
                        onChange={(e) => {
                          field.onChange(e.target.checked);
                          handleShowUpdateTicketSelectionChanged(e);
                        }}
                        checked={field.value}
                        data-checked={field.value}
                      />
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

ValetAreaUpdateTicketSettingsForm.defaultProps = {
  settingValues: {},
};

export default ValetAreaUpdateTicketSettingsForm;
